import $ from "jquery";
import "jquery-ui/ui/widgets/tabs";
import uid from "flow/utils/uid";
import { ITabsWrapper } from "flow/interfaces/ITabsWrapper";

function createWrapper(element: HTMLElement): ITabsWrapper {
    let isCreatedFlag = false;

    function create(options?: JQueryUI.TabsOptions): void {
        const prefix = "tabid_" + uid.next() + "_";

        $(element)
            .find("ul li a")
            .each(function (index) {
                $(this).attr("href", "#" + prefix + index.toString());
            });

        $(element)
            .children("div")
            .each(function (index) {
                $(this).attr("id", prefix + index.toString());
            });

        if (!isCreated()) {
            if (options) {
                $(element).tabs(options);
            } else {
                $(element).tabs();
            }
        } else {
            refresh();
        }

        isCreatedFlag = true;
    }

    function refresh(): void {
        $(element).tabs("refresh");
    }

    function isCreated(): boolean {
        return isCreatedFlag;
    }

    function setActiveTab(index: number): void {
        $(element).tabs("option", "active", index);
    }

    function getActiveTab(): number {
        return $(element).tabs("option", "active");
    }

    function hideTab(index: number): void {
        const tab = $(element).find("ul li.ui-tabs-tab")[index];
        $(tab).hide();
    }

    function showTab(index: number): void {
        const tab = $(element).find("ul li.ui-tabs-tab")[index];
        $(tab).show();
    }

    function showTabs(): void {
        const allTabs = $(element).find("ul li.ui-tabs-tab");
        $(allTabs).show();
    }

    function disableTab(index: number): void {
        const list = $(element).tabs("option", "disabled");
        if (typeof list !== "boolean") {
            if (list.indexOf(index) === -1) {
                list.push(index);
                $(element).tabs("option", "disabled", list);
            }
        } else {
            $(element).tabs("option", "disabled", [index]);
        }
    }

    function disableTabs(): void {
        $(element).tabs("disable");
    }

    function enableTabs(): void {
        $(element).tabs("option", "disabled", []);
    }

    return {
        create,
        refresh,
        isCreated,
        setActiveTab,
        getActiveTab,
        disableTab,
        enableTabs,
        disableTabs,
        hideTab,
        showTab,
        showTabs
    };
}

export default {
    createWrapper: createWrapper
};
